import { isAfter, parse } from "date-fns";
import { format } from "date-fns-tz";

export const formatDate = (date: Date | null | "invalid"): string | null => {
  return date && date !== "invalid"
    ? date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
    : null;
};

export function today() {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date;
}

export function validateDate(dateString: string, disableFuture: boolean): Date | "invalid" {
  let day = today();
  day.setHours(0, 0, 0, 0);

  let result = parseDate(dateString);

  if (result === "invalid") return result;

  if (disableFuture && isAfter(result, day)) return "invalid";

  return result;
}

export function parseDate(dateString: string): Date | "invalid" {
  let date = today();
  const time = Date.parse(dateString);
  date.setTime(time);
  return isNaN(time) ? "invalid" : date;
}

export function formatlocalDateToMonthDayYear(strDate: string): string {
  let parsedDate = parse(strDate, "yyyy-MM-dd", new Date());
  return format(parsedDate, "MM/dd/yyyy");
}

export function dateToYearMonthDay(utcDate: Date, pattern: string = "yyyy-MM-dd"): string {
  return format(utcDate, pattern, { timeZone: "GMT" });
}
